import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(productDescriptionStyles, {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
                @media print {
                    font-size: ${TYPOGRAPHY.size.smaller} !important;
                }
            `,
            weight: TYPOGRAPHY.weight.bold,
        },
        color: `${COLORS.lightBlack}`,
    },
});
